module.exports = __webpack_public_path__ + "static/media/bombbanner_sm4.2320eb0a.png";